import { Component } from '@angular/core';
@Component({
    selector: 'sales-dashboard',
    templateUrl: './sales-dashboard.component.html'
})

export class SalesDashboardComponent {

    constructor() { }

    ngOnInit() {
    }
}
